// constants/paths.js
export const DASHBOARD_PATHS = {
    HOME: "/", 
    FLEET: "/fleet/*",
    EDGE_DEVICES: "/edge-devices",
    IOT_GATEWAYS: "/iot-gateways",
    SETTINGS: "/settings",
}; 